import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { Container, ThemeToggle } from '@/components/ui';

import { BrandLogo } from './brand-logo';
import { LegalLink } from './legal-dialog';

const COLUMNS = [
	{
		title: 'Platform',
		links: [
			{ to: '/auctions', label: 'Browse Auctions' },
			{ to: '/how-it-works', label: 'How It Works' },
			{ to: '/pricing', label: 'Pricing' },
		],
	},
	{
		title: 'Logistics',
		links: [
			{ to: '/shipping', label: 'Shipping' },
			{ to: '/faq', label: 'FAQ' },
			{ to: '/contact', label: 'Contact' },
		],
	},
] as const;

export function SiteFooter(): ReactNode {
	return (
		<footer className="mt-auto border-t border-border bg-surface-muted">
			<Container className="grid gap-10 py-12 md:grid-cols-4">
				<div className="md:col-span-2">
					<BrandLogo />
					<p className="mt-2 max-w-sm text-sm leading-relaxed text-fg-muted">
						A B2B platform for professional buyers and dealers. Search Copart and IAAI in one
						place, bid, and ship worldwide.
					</p>
				</div>

				{COLUMNS.map((col) => (
					<div key={col.title}>
						<p className="text-xs font-semibold uppercase tracking-wider text-fg-subtle">
							{col.title}
						</p>
						<ul className="mt-3 space-y-2">
							{col.links.map((l) => (
								<li key={l.to}>
									<Link to={l.to} className="text-sm text-fg-muted hover:text-fg">
										{l.label}
									</Link>
								</li>
							))}
						</ul>
					</div>
				))}
			</Container>

			<div className="border-t border-border">
				<Container className="flex flex-col gap-3 py-5 text-sm text-fg-subtle sm:flex-row sm:items-center sm:justify-between">
					<p>© {new Date().getFullYear()} Sirius Hub. All rights reserved.</p>
					<div className="flex items-center gap-5">
						<ThemeToggle className="hidden sm:flex" />
						<LegalLink doc="terms" className="hover:text-fg">
							Terms &amp; Conditions
						</LegalLink>
						<LegalLink doc="privacy" className="hover:text-fg">
							Privacy Policy
						</LegalLink>
					</div>
				</Container>
			</div>
		</footer>
	);
}
